import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminProtectedRoute = ({ children }) => {
    const { isAdminAuthenticated } = useAuth();

    if (!isAdminAuthenticated) {
        return <Navigate to="/admin" replace />;
    }

    return children;
};

export default AdminProtectedRoute;
